import { CaretRightIcon } from "@phosphor-icons/react/dist/csr/CaretRight";
import { Card, CardContent } from "@volca/ui/components/ui/card";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { cn } from "@volca/ui/lib/utils";
import type { OnboardingStepPane } from "@/onboarding/routes";
import { useGuide } from "./guide-context";
import { STEP_GUIDES } from "./guides";

/**
 * The guides for the current step, listed beside it. The step says what to do, and these
 * say how, for whichever system the customer happens to use. Opening one slides the
 * guide in beside the step, which stays where it is.
 */
export const GuideAside = ({
  activePane,
}: {
  activePane: OnboardingStepPane;
}) => {
  const guides = STEP_GUIDES[activePane];
  const guide = useGuide();

  if (!guides?.length) return null;

  return (
    <Card className="w-full gap-0 py-0">
      <CardContent className="p-0">
        <Stack className="w-full" gap={0} align="stretch">
          <Text
            weight="semibold"
            variant="caption"
            className="px-4 pt-3 pb-2"
            tone="muted"
          >
            Guides
          </Text>
          {guides.map((entry, index) => (
            <button
              key={entry.id}
              type="button"
              onClick={() => guide?.setOpen(entry)}
              aria-current={guide?.open?.id === entry.id}
              className={cn(
                "flex w-full items-center gap-2 border-t border-line px-4 py-2.5 text-left transition-colors",
                { "border-t-0": index === 0 },
                {
                  "bg-selected text-brand hover:bg-selected-hovered":
                    guide?.open?.id === entry.id,
                  "hover:bg-neutral-subtle-hovered":
                    guide?.open?.id !== entry.id,
                },
              )}
            >
              <Text className="min-w-0 flex-1">{entry.title}</Text>
              <CaretRightIcon
                className={cn("h-4 w-4 shrink-0", {
                  "text-brand": guide?.open?.id === entry.id,
                  "text-subtle": guide?.open?.id !== entry.id,
                })}
              />
            </button>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
